import React from 'react';

const TRANSITIONS = [
  { value: 'none', label: 'None (cut)' },
  { value: 'fade', label: 'Fade (0.3s)' },
  { value: 'dissolve', label: 'Dissolve (0.5s)' },
  { value: 'slide-left', label: 'Slide Left (0.3s)' },
  { value: 'slide-right', label: 'Slide Right (0.3s)' },
  { value: 'zoom-in', label: 'Zoom In (0.5s)' },
  { value: 'wipe', label: 'Wipe (0.3s)' },
];

interface TransitionPickerProps {
  currentTransition: string;
  onSelect: (transition: string) => void;
  onClose: () => void;
}

const TransitionPicker: React.FC<TransitionPickerProps> = ({ currentTransition, onSelect, onClose }) => {
  return (
    <div className="transition-picker dropdown-menu">
      <div className="dropdown-header">Transitions</div>
      {TRANSITIONS.map(t => (
        <button
          key={t.value}
          className={`dropdown-item ${currentTransition === t.value ? 'dropdown-item--active' : ''}`}
          onClick={() => { onSelect(t.value); onClose(); }}
        >
          {currentTransition === t.value && <span className="dropdown-check">✓</span>}
          {t.label}
        </button>
      ))}
    </div>
  );
};

export default TransitionPicker;
